import React from 'react';

import Icon from '../Icon/Icon';

const TipsAndTutorialsBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M17.625 6C19.289 6 20.8263 6.54204 22.0703 7.45898C21.8144 7.82122 21.6503 8.25446 21.6123 8.72656C20.6121 21.165 20.8998 28.6094 21.6436 40.833C20.4819 41.5717 19.1036 42 17.625 42H15.375C14.5172 42 13.6963 41.8397 12.9414 41.5479C12.5876 41.4108 12.375 41.0581 12.375 40.6787V7.32129C12.375 6.94185 12.5876 6.58918 12.9414 6.45215C13.6963 6.16034 14.5172 6 15.375 6H17.625ZM22.9307 8.19922C24.2865 9.55626 25.125 11.4302 25.125 13.5V34.5C25.125 36.6747 24.1994 38.633 22.7207 40.0029C22.013 28.2507 21.7601 20.9191 22.7334 8.81641C22.7515 8.59117 22.8216 8.38187 22.9307 8.19922ZM11.25 39.4443C9.88102 38.3687 9.00001 36.7002 9 34.8242V13.375C9 11.4988 9.88076 9.8295 11.25 8.75391V39.4443Z'
                fill='#393E44'
            />
            <path d='M9 30H11.25' stroke='#00D1D2' strokeWidth='2' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.7337 8.81653C22.7935 8.07239 23.4163 7.5 24.1629 7.5H27.2121C27.9587 7.5 28.5815 8.07239 28.6414 8.81653C28.7847 10.599 28.9015 12.278 28.9941 13.8829C28.235 14.5017 27.7502 15.4443 27.7502 16.5V39.8571C27.7502 40.5706 27.9926 41.2275 28.3994 41.7499C28.2672 41.9031 28.0724 42 27.8565 42H23.5186C23.1388 42 22.8243 41.7004 22.801 41.3214C22.0335 28.7849 21.7245 21.3655 22.7337 8.81653ZM29.0831 15.5541C29.4376 22.8228 29.2847 28.7002 28.8752 36.1785V16.5C28.8752 16.1621 28.9497 15.8417 29.0831 15.5541Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M27.7509 16.5498C27.2073 16.6413 26.656 16.6875 26.1025 16.6875L24.8992 16.6875C24.0046 16.6875 23.1157 16.5667 22.2562 16.3296C22.2391 16.7168 22.2233 17.1002 22.209 17.4804C23.087 17.7005 23.9905 17.8125 24.8992 17.8125H26.1025C26.6554 17.8125 27.2064 17.771 27.7509 17.689V16.5498ZM28.8855 16.2898C28.9439 16.2728 29.002 16.2553 29.06 16.2372C29.0784 16.6269 29.0953 17.0129 29.1108 17.3956C29.0327 17.4177 28.9544 17.4389 28.8759 17.4592V16.5C28.8759 16.4291 28.8791 16.359 28.8855 16.2898Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M25.6875 10.9141C26.1837 10.9141 26.5859 11.3163 26.5859 11.8125L26.5859 12.5313C26.5859 13.0274 26.1837 13.4297 25.6875 13.4297C25.1913 13.4297 24.7891 13.0274 24.7891 12.5313L24.7891 11.8125C24.7891 11.3163 25.1913 10.9141 25.6875 10.9141Z'
                fill='#00D1D2'
            />
            <path
                d='M28.875 16.5C28.875 15.2574 29.8824 14.25 31.125 14.25H37.107C38.3496 14.25 39.357 15.2574 39.357 16.5V39.8571C39.357 40.9387 38.4802 41.8154 37.3987 41.8154H30.8333C29.7518 41.8154 28.875 40.9387 28.875 39.8571V16.5Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M28.8754 22.3546H39.3574V23.4796H28.8754V22.3546Z'
                fill='#FFFDFB'
            />
            <path
                d='M35.2112 18.4249C35.2112 19.0301 34.7206 19.5207 34.1153 19.5207C33.5101 19.5207 33.0195 19.0301 33.0195 18.4249C33.0195 17.8197 33.5101 17.3291 34.1153 17.3291C34.7206 17.3291 35.2112 17.8197 35.2112 18.4249Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default TipsAndTutorialsBlueIcon;
